module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('em', [_vm._v("Praise for")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('strong', [_vm._v("L. A. BANKS")]), _c('br'), _vm._v("&"), _c('br'), _c('em', [_vm._v("The Vampire Huntress Legend series")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("THE WICKED")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“A complex world of good vs. evil . . . The story is so compelling, the whole series must be read.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Birmingham Times")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("THE CURSED")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“A wild amalgam of Christianity, vampire lore, world myth, functional morality, street philosophy, and hot sex . . . Fans couldn’t ask for more.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("THE FORSAKEN")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Readers already enthralled with this sizzling series can look forward to major plot payoffs.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("THE DAMNED")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“All hell breaks loose—literally—in the complex sixth installment . . . stunning.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("THE FORBIDDEN")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Passion, mythology, war and love that lasts till the grave-and beyond . . . Fans should relish this new chapter in a promising series.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—"), _c('em', [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MORE . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("“Superior vampire fiction.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Gripping.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Kirkus Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("THE BITTEN")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Seductive . . . mixing religion with erotic horror dosed with a funky African-American beat, Banks blithely piles on layer after layer of densely detailed plot . . . [that] will delight established fans. Banks creates smokin’ sex scenes that easily out-vamp Laurell K. Hamilton’s.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The stakes have never been higher, and the excitement and tension are palpable in this installment of Banks’ complex, sexy series.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The storyline and the action are intense, and this book is a page-turner that showcases Ms. Banks’ writing to perfection. While the storyline is fascinating, the characters make this series one of the most enjoyable I have ever read . . . unforgettable, toe-curling love scenes . . . an excellent read. Ms. Banks has written a book of passion, romance, action, horror and intrigue. Sit back, hold on and enjoy the ride!”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Romance in Color")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("THE HUNTED")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“A terrifying roller-coaster ride of a book.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—Charlaine Harris")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“A spellbinding thrill ride.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—Zane")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“The well-conceived and intricate rules of Banks’ vampire-inhabited world provide endless opportunities for riffs on the meaning of power and sex that will please lovers of similar . . . philosophical musings found in the vampire tales of Anne Rice and Laurell K. Hamilton.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v("“Hip, fresh, and fantastic.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—Sherrilyn Kenyon,"), _c('br'), _c('em', [_vm._v("New York Times")]), _vm._v(" bestselling author of"), _c('br'), _c('em', [_vm._v("Dark Side of the Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("THE AWAKENING")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“An intriguing portrait of vampiric society, reminiscent of Anne Rice and Laurell K. Hamilton.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Library Journal")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“With "), _c('em', [_vm._v("The Awakening")]), _vm._v(", Banks solidifies her intriguing, dark series as a project worth watching.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Booklist")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Again, Banks brilliantly combines spirituality, vampires, and demons (and hip-hop music) into a fast-paced tale that is sure to leave fans of her first novel, "), _c('em', [_vm._v("Minion")]), _vm._v(", panting for more.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Columbus Dispatch")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("MINION")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Banks’ mastery of character creation shines through in the strong-willed Damali . . . a sure-fire hit . . . pretty dramatic fiction.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Philadelphia Daily News")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“["), _c('em', [_vm._v("Minion")]), _vm._v("] literally rocks the reader into the action-packed underworld power struggle between vampire rivals with a little demon juice thrown in.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Philadelphia Sunday Sun")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Banks [is] wildly creative and invents a totally new and refreshing milieu.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Fangoria")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“[A] tough, sexy new vampire huntress challenges the dominance of Anita Blake and Buffy . . . Damali is an appealing heroine, the concept is intriguing, and the series promising.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—Amazon.com")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79dfe612","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/abouttheauthor.vue
// module id = 60
// module chunks = 0